import { useEffect, useState } from "react"
import { Header } from "../Header/Header"
import { Footer } from "../../Footer/Footer"
import { CoursePreviewModal } from "./CoursePreviewModal"
import "./InsuranceCourse.css"

export const InsuranceCourseSection = () => {
    const [activeFilter, setActiveFilter] = useState("all")
    const [selectedEpisode, setSelectedEpisode] = useState(null)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    const filterPills = [
        { label: "All Episodes", filterValue: "all" },
        { label: "Shipowners", filterValue: "Shipowner" },
        { label: "Charterers", filterValue: "Charterers" },
        { label: "Insurance", filterValue: "Insurance" },
        { label: "Brokers", filterValue: "Brokers" },
        { label: "Advocates", filterValue: "Advocates" },
        { label: "Freight Forwarders", filterValue: "Freight" },
        { label: "Students", filterValue: "student" },
    ]

    const episodesData = [
        {
            num: "01",
            title: "Carriage of Goods by Sea Act",
            duration: "26 Min",
            audiences: ["Shipowner", "Charterers", "Insurance Companies", "Advocates", "Freight Forwarders"],
            colorClass: "col-0",
            videoUrl: "https://www.youtube.com/watch?v=KDkZd__A51U"
        },
        {
            num: "02",
            title: "Seaworthiness",
            duration: "26 Min",
            audiences: ["Shipowner", "Charterers", "Insurance Companies", "Brokers", "Advocates", "Freight Forwarders"],
            colorClass: "col-1",
            videoUrl: "https://www.youtube.com/watch?v=KDkZd__A51U"
        },
        {
            num: "03",
            title: "Degree of Fault",
            duration: "14 Min",
            audiences: ["Shipowner", "Charterers", "Insurance Companies", "Brokers", "Advocates", "Freight Forwarders"],
            colorClass: "col-2",
            videoUrl: "https://www.youtube.com/watch?v=KDkZd__A51U"
        },
        {
            num: "04",
            title: "Due Diligence — Carriage of Goods by Sea Act",
            duration: "21 Min",
            audiences: ["Shipowner", "Charterers", "Insurance Companies", "Brokers", "Advocates", "Freight Forwarders", "Marine Insurance Students"],
            colorClass: "col-3",
            videoUrl: "https://www.youtube.com/watch?v=KDkZd__A51U"
        },
        {
            num: "05",
            title: "Marine Insurance Act & Policy of Marine Insurance",
            duration: "38 Min",
            audiences: ["Shipowner", "Charterers", "Insurance Companies", "Brokers", "Advocates", "Freight Forwarders", "Marine Insurance Students"],
            colorClass: "col-4",
            videoUrl: "https://www.youtube.com/watch?v=KDkZd__A51U"
        },
        {
            num: "06",
            title: "Privity & Case Studies",
            duration: "24 Min",
            audiences: ["Shipowner", "Charterers", "Insurance Companies", "Brokers", "Advocates", "Freight Forwarders"],
            colorClass: "col-5",
            videoUrl: "https://www.youtube.com/watch?v=KDkZd__A51U"
        },
        {
            num: "07",
            title: "Marine Policies — Valued & Unvalued",
            duration: "11 Min",
            audiences: ["Shipowner", "Charterers", "Insurance Companies", "Brokers"],
            colorClass: "col-6",
            videoUrl: "https://www.youtube.com/watch?v=KDkZd__A51U"
        }
    ]

    const filteredEpisodes = episodesData.filter(episode => {
        if (activeFilter === "all") return true
        return episode.audiences.some(aud =>
            aud.toLowerCase().includes(activeFilter.toLowerCase())
        )
    })

    return (
        <>
            <div className="container-fluid">
                <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                    <div className="col-12">
                        <Header actives="InsuranceCourseSection" subactive="Events" />

                        <div className="insurance-course-page">
                            {/* HERO */}
                            <header className="hero-header">
                                <div className="hero-deco">
                                    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="100" cy="100" r="90" stroke="white" strokeWidth="1" />
                                        <circle cx="100" cy="100" r="65" stroke="white" strokeWidth="1" />
                                        <circle cx="100" cy="100" r="40" stroke="white" strokeWidth="1" />
                                        <line x1="10" y1="100" x2="190" y2="100" stroke="white" strokeWidth="1" />
                                        <line x1="100" y1="10" x2="100" y2="190" stroke="white" strokeWidth="1" />
                                        <line x1="36" y1="36" x2="164" y2="164" stroke="white" strokeWidth="0.5" />
                                        <line x1="164" y1="36" x2="36" y2="164" stroke="white" strokeWidth="0.5" />
                                        <circle cx="100" cy="100" r="5" fill="white" />
                                    </svg>
                                </div>
                                <div className="hero-container">
                                    <div className="hero-anchor">Maritime Education Series</div>
                                    <h2 className="hero-title">Maritime Law &amp;<br /><em>Insurance</em> Course</h2>
                                    <p className="hero-desc">A structured video programme covering the legal and insurance frameworks that govern modern maritime trade — from seaworthiness to marine policies.</p>
                                    <div className="hero-stats">
                                        <div className="stat-item">
                                            <div className="stat-num">7</div>
                                            <div className="stat-label">Episodes</div>
                                        </div>
                                        <div className="stat-item">
                                            <div className="stat-num">2h 40m</div>
                                            <div className="stat-label">Total Duration</div>
                                        </div>
                                        <div className="stat-item">
                                            <div className="stat-num">6+</div>
                                            <div className="stat-label">Audience Types</div>
                                        </div>
                                    </div>
                                </div>
                            </header>

                            {/* FILTER BAR */}
                            <nav className="filter-bar" aria-label="Filter by audience">
                                <span className="filter-label">Audience</span>
                                <div className="filter-pills">
                                    {filterPills.map((pill) => (
                                        <button
                                            key={pill.filterValue}
                                            className={`pill ${activeFilter === pill.filterValue ? 'active' : ''}`}
                                            onClick={() => setActiveFilter(pill.filterValue)}
                                        >
                                            {pill.label}
                                        </button>
                                    ))}
                                </div>
                            </nav>

                            {/* MAIN */}
                            <main className="main-content">
                                <div className="section-header">
                                    <h2 className="section-title">Episode Catalogue</h2>
                                    <span className="ep-count">
                                        {filteredEpisodes.length} {filteredEpisodes.length === 1 ? 'episode' : 'episodes'}
                                    </span>
                                </div>

                                <div className="episode-list">
                                    {filteredEpisodes.map((episode, index) => (
                                        <div
                                            key={episode.num}
                                            className="ep-card"
                                            style={{ animationDelay: `${index * 0.05}s` }}
                                        >
                                            <div className="ep-num-wrap">
                                                <div className={`ep-circle ${episode.colorClass}`}>
                                                    {episode.num}
                                                </div>
                                            </div>
                                            <div className="ep-body">
                                                <div className="ep-title">{episode.title}</div>
                                                <div className="ep-audience-wrap">
                                                    {episode.audiences.map((aud) => (
                                                        <span key={aud} className="aud-tag">
                                                            {aud}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="ep-meta">
                                                <div>
                                                    <div className="ep-time">{episode.duration}</div>
                                                    <div className="ep-time-label">Duration</div>
                                                </div>
                                                <div className="ep-badge">
                                                    {episode.audiences.length} {episode.audiences.length === 1 ? 'audience' : 'audiences'}
                                                </div>
                                            </div>
                                            <div className="ep-play-btn-col">
                                                <button
                                                    className="play-circle-btn"
                                                    title="Play Course Preview"
                                                    onClick={() => setSelectedEpisode(episode)}
                                                >
                                                    <i className="fas fa-play"></i>
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {filteredEpisodes.length === 0 && (
                                    <p className="no-results">No episodes match this audience filter.</p>
                                )}
                            </main>
                        </div>

                        {/* UDEMY-STYLE PREVIEW MODAL */}
                        {selectedEpisode && (
                            <CoursePreviewModal
                                selectedEpisode={selectedEpisode}
                                episodesData={episodesData}
                                onClose={() => setSelectedEpisode(null)}
                                onSelectEpisode={(episode) => setSelectedEpisode(episode)}
                            />
                        )}

                        <Footer />
                    </div>
                </div>
            </div>
        </>
    )
}
